import { HttpParams } from '@angular/common/http';
import { inject, Injectable, LOCALE_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsBuilderService {
  private readonly locale = inject(LOCALE_ID);

  public new(): QueryParamsBuilder {
    return new QueryParamsBuilder(this.locale);
  }
}

export class QueryParamsBuilder {
  private params = new HttpParams();

  constructor(locale: string) {
    this.setParam('locale', locale);
  }

  public setParam(key: string, value: string | number | boolean): this {
    this.params = this.params.append(key, value);
    return this;
  }

  public setModulePopulationParam(
    moduleKey: string,
    keySuffix: string | number | boolean,
    value: string | number | boolean = '*',
  ): this {
    return this.setParam(
      `populate[modules][on][modules.${moduleKey}][populate]${keySuffix}`,
      value,
    );
  }

  public build(): HttpParams {
    return this.params;
  }
}
